import React, { useRef } from 'react'

const ALERT_WORDS = { kind: 'Alert type', label: 'Alert name', category: 'Category', severity: 'Severity', raised_at: 'Raised at', environment: 'Environment' }
const ALERT_TOKENS = Object.entries(ALERT_WORDS).map(([k, label]) => ({ token: `{{alert.${k}}}`, label }))

// A choice's words (core names them in its own terms: "trigger",
// "staff_alert"), and help the admin writes itself in place of the server's
// (which names those terms).
export const MAPPING_OPTION_WORDS = { emailTemplate: { trigger: "The alert's own email (what staff get today)", staff_alert: 'A general alert email, from the fields below' } }
export const MAPPING_HELP = { emailTemplate: null }
const optionWords = (m, o) => ((MAPPING_OPTION_WORDS[m.key] || {})[o]) || o
const helpOf = m => (Object.prototype.hasOwnProperty.call(MAPPING_HELP, m.key) ? MAPPING_HELP[m.key] : m.help)

// MappingForm draws an action's mapping form from its type's MappingSchema
// (spec §12.3): {{…}} templates, an insert-a-field picker listing the
// trigger's payload fields, and the default mapping as each placeholder.
export const MappingForm = ({ schema, value, defaults = {}, fields = [], onChange }) => {
  const focused = useRef(null)
  const tokens = [...fields.map(f => ({ token: `{{payload.${f.key}}}`, label: f.label })), ...ALERT_TOKENS]
  const set = (k, v) => onChange({ ...value, [k]: v })
  const insert = (k, token) => set(k, `${value[k] !== undefined && value[k] !== '' ? value[k] : defaults[k] || ''}${token}`)
  return (
    <div className="ar-form">
      {schema.map(m => {
        const id = `ar-map-${m.key}`
        if (m.kind === 'enum') {
          return (
            <div className="sw-field" key={m.key}>
              <label className="sw-label" htmlFor={id}>{m.label}</label>
              <select id={id} className="form-select" value={value[m.key] || m.options[0]} onChange={e => set(m.key, e.target.value)}>
                {m.options.map(o => <option key={o} value={o}>{optionWords(m, o)}</option>)}
              </select>
              {helpOf(m) && <div className="sw-hint">{helpOf(m)}</div>}
            </div>
          )
        }
        if (m.kind === 'template_list') {
          const rows = value[m.key] || []
          return (
            <fieldset className="sw-field" key={m.key}>
              <legend className="sw-label">{m.label}</legend>
              {rows.map((r, i) => (
                <div className="ar-row" key={i}>
                  <input aria-label={`${m.label} ${i + 1} label`} className="form-control" value={r.label}
                    onChange={e => set(m.key, rows.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} />
                  <input aria-label={`${m.label} ${i + 1} value`} className="form-control" value={r.value}
                    onChange={e => set(m.key, rows.map((x, j) => (j === i ? { ...x, value: e.target.value } : x)))} />
                  <button type="button" className="btn btn-sm sw-btn-outline-danger" onClick={() => set(m.key, rows.filter((_, j) => j !== i))}>Remove</button>
                </div>
              ))}
              {rows.length < 10 && <button type="button" className="btn sw-btn btn-sm" onClick={() => set(m.key, [...rows, { label: '', value: '' }])}>Add field</button>}
            </fieldset>
          )
        }
        return (
          <div className="sw-field" key={m.key}>
            <label className="sw-label" htmlFor={id}>{m.label}</label>
            <input id={id} className="form-control" maxLength={m.maxLen || undefined} placeholder={defaults[m.key] || ''}
              value={value[m.key] || ''} onFocus={() => { focused.current = m.key }} onChange={e => set(m.key, e.target.value)} />
            <select aria-label={`Insert a field into ${m.label}`} className="form-select form-select-sm ar-token" value=""
              onChange={e => e.target.value && insert(m.key, e.target.value)}>
              <option value="">Insert a field…</option>
              {tokens.map(t => <option key={t.token} value={t.token}>{t.label}</option>)}
            </select>
          </div>
        )
      })}
    </div>
  )
}
